import { render, staticRenderFns } from "./CadastroOfertaParticular.vue?vue&type=template&id=6f0e511a&"
import script from "./CadastroOfertaParticular.vue?vue&type=script&lang=js&"
export * from "./CadastroOfertaParticular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports